// extracted by mini-css-extract-plugin
export default {"container":"bo-z","bubbleNav":"co-z","graphic":"do-z","contact":"eo-z"};